import React, { useMemo } from "react";
import { Card, GridLegacy, MenuItem } from "@mui/material";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import CardBody from "../../../../components/Card/CardBody";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import { useFormContext, useWatch } from "react-hook-form";
import Button from "../../../../components/CustomButtons/Button";
import { _get } from "../../../../http";

function Webhooks() {
  const { vestigingId, reloadDataFromServer } = useFormContext();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper tDefault={"Webhook configuration"} tKey={"vestigingen.form.mail.headers.webhooks"} />
            </h3>
            <FormTextTC
              name={"custom_data.webhooks.new_order"}
              tDefault={"New order"}
              tKey={"custom_data.webhooks.new_order"}
            />
            <FormTextTC
              name={"custom_data.webhooks.orders_changes"}
              tDefault={"Order changed"}
              tKey={"custom_data.webhooks.orders_changes"}
            />
            <FormTextTC
              name={"custom_data.webhooks.order_api_errors"}
              tDefault={"Order API issues"}
              tKey={"custom_data.webhooks.order_api_errors"}
            />
            <FormTextTC
              name={"custom_data.webhooks.new_printjob"}
              tDefault={"New print job"}
              tKey={"custom_data.webhooks.new_printjob"}
            />
            <FormTextTC
              name={"custom_data.webhooks.printjob_changes"}
              tDefault={"Changed print job"}
              tKey={"custom_data.webhooks.printjob_changes"}
            />
            <FormTextTC
              name={"custom_data.webhooks.menu_changes"}
              tDefault={"Menu changes"}
              tKey={"custom_data.webhooks.menu_changes"}
            />
          </GridLegacy>
        </GridLegacy>
      </Card>
    </div>
  );
}

export default Webhooks;
